import { useTranslation } from 'react-i18next';
import { Col, Row, Text, Title } from 'ui';
import variables from 'common/styles/variables.json';

type P = {
  additionalTitle?: string;
};

const WelcomeHeader = ({ additionalTitle }: P) => {
  const { t } = useTranslation();

  return (
    <Row gutter={[0, variables.spaceXs.value * 5]}>
      <Col span={24}>
        <Row gutter={[0, 'xxs']}>
          <Col span={24}>
            <Text weight="medium">{`${t('Welcome to')} ${import.meta.env.VITE_APP_TITLE}!`}</Text>
          </Col>
          <Col span={24}>
            <Title level={2}>What&apos;s next?</Title>
          </Col>
        </Row>
      </Col>

      {additionalTitle ? (
        <Col span={24}>
          <Title level={1} marginBottom>
            {additionalTitle}
          </Title>
        </Col>
      ) : null}
    </Row>
  );
};

export default WelcomeHeader;
